import { type File } from '../../../../../api'

export const file1: File = {
  __typename: 'File',
  id: 'RmlsZTplMGJlNzVmMC01MjhmLTRiM2EtYTY4YS1kNjhlMTJjODMwZDI=',
  name: 'Hill Chart',
  publicUrl:
    'https://storage.googleapis.com/s.mkswft.com/RmlsZTplMGJlNzVmMC01MjhmLTRiM2EtYTY4YS1kNjhlMTJjODMwZDI=/Hill%20Chart.png',
  extension: 'png',
  dimensions: {
    width: 2700,
    height: 1119,
  },
}
